export const validateFormRequiredFields = (data, requiredFields) => {
  if (!data || typeof data !== 'object') return []
  if (!requiredFields || typeof requiredFields !== 'object') return []

  const missingFields = Object.entries(requiredFields).reduce((missingFields, [key, label]) => {
    if (!data[key] && data[key] !== 0) {
      missingFields.push(label)
    }

    return missingFields
  }, [])

  if (missingFields.length > 0) {
    throw new Error(`Please fill in required fields: ${missingFields.join(', ')}`)
  }
}
